import { useMutation, useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";
import useModal from "./useModalPlanejamentoOperacoes";

function getVinculo(list: any[], operacao: any) {
  if (list?.length === 0) return undefined;

  const referenciaId = operacao?.operacao_planoOperacionalOperacaoReferenciaId;
  if (!referenciaId) return undefined;

  const vinculo = list.find((item) => item?.operacao_planoOperacionalOperacaoId === referenciaId);
  if (!vinculo) return undefined;

  return {
    vinculoSequencia: vinculo?.sequencia || '',
    vinculoOperacao: vinculo?.operacao_operacao || '',
    vinculoDescricao: vinculo?.plano_descricao || '',
  };
}

export function handleFormatOperacoes(data: any[]) {
  const result: any[] = [];

  data.forEach((item) => {
    const { planoOperacionalOperacoes = [], ...parentProps } = item;

    planoOperacionalOperacoes.forEach((operacao: any) => {
      const { talhoes = [], ...operacaoProps } = operacao;

      talhoes.forEach((talhao: any) => {
        result.push({
          ...talhao,
          ...Object.fromEntries(
            Object.entries(parentProps).map(([key, value]) => [`plano_${key}`, value])
          ),

          ...Object.fromEntries(
            Object.entries(operacaoProps).map(([key, value]) => [`operacao_${key}`, value])
          ),
        });
      });
    });
  });

  result.forEach((item, index: number) => {
    const vinculo = getVinculo(result, item);
    item.vinculoDescricao = vinculo?.vinculoDescricao;
    item.vinculoOperacao = vinculo?.vinculoOperacao;
    item.vinculoSequencia = vinculo?.vinculoSequencia;
  });

  return result;
}

export function useGetListaPorTalhao(id: string, filters: any, isOpen: boolean) {
  const { setListPlanoOperacionalTalhao } = useModal()
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_LISTA_POR_TALHAO, id, filters],
    async () => {
      const { data } = await http.get<any, any>(URL.PLANO_OPERACIONAL.OBTER_LISTA_POR_TALHAO(id), {
        params: filters,
      });

       const res = handleFormatOperacoes(data);

        const sorted = [...res].sort((a: any, b: any) => {
          const getDataOrdenacao = (item: any) => {
            const dataRef =
              item?.periodoDataInicio && item?.periodoDataFim
                ? item.periodoDataInicio
                : item?.dataProgramada;

            return dataRef ? new Date(dataRef).getTime() : Infinity;
          };

          return getDataOrdenacao(a) - getDataOrdenacao(b);
        });

        sorted.forEach((item, index: number) => {
          item.index = index + 1;
        });
              
      setListPlanoOperacionalTalhao(sorted);
      return sorted as any[];
    },
    {
      keepPreviousData: true,
      enabled: !!id && isOpen,
    }
  );
}

export function useGetHistoricoOrdemServico(id: string, isOpen: boolean) {
   return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_HISTORICO_TALHAO_ORDEM_SERVICO, id],
    async () => {
      const { data } = await http.get<any, any>(URL.PLANO_OPERACIONAL.OBTER_HISTORICO_TALHAO_ORDEM_SERVICO(id));

      return data as any[];
    },
    {
      keepPreviousData: true,
      enabled: !!id && isOpen,
    }
  );
}

export function useGetHistoricoTalhao(id: string) {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_HISTORICO_TALHAO, id],
    async () => {
      const { data } = await http.get<any, any>(URL.PLANO_OPERACIONAL.OBTER_HISTORICO_TALHAO(id));

      return data as any[];
    },
    {
      keepPreviousData: true,
      enabled: !!id,
    }
  );
}

export function useAtualizarOrdemServicoTalhoes() {
  return useMutation(async ({ body }: { body: any }) => {
    const response = await http.put(URL.PLANO_OPERACIONAL.CRIAR_OPERACAO_AVULSA, body);
    return response;
  });
}
export function useOperacaoOrdemServicoTalhoes() {
  return useMutation(async ({ body }: { body: any }) => {
    const response = await http.put(URL.PLANO_OPERACIONAL.OBTER_ORDEM_SERVICO_TALHAO, body);
    return response;
  });
}